import ImageProps, { ImageLayerProps, LayerAreaSelection } from "../imageStudio/images";

export const stateIconError =  '❌';
export const stateIconDone = '✅';
export const stateIconSend = '⇄';
export const stateIconWaiting = '⏳';
export const stateIconUnavailable = 'ℹ️';

// 'unavailable' = cProxy hat die Funktion in dieser Umgebung abgelehnt (HTTP 403, Modell-Policy):
// Endzustand wie 'error' (Seite wird wieder bedienbar), aber neutral statt rot angezeigt.
export type aiStateTypes = 'done' | 'waiting' | 'error' | 'send' | 'unavailable' | null;

export type AiSelectionContext = {
    sourceType: "base" | "layer";
    selection: LayerAreaSelection;
    sourceImage: ImageProps | ImageLayerProps;
    sourceLayerGeometry: {
        position: { x: number; y: number };
        width: number;
        height: number;
        rotation: number;
    };
};